import DocuformsPage from "./views/DocuformsPage";
import DocuformDeleteConfirmationDialog from "./views/DocuformDeleteConfirmationDialog";

const routes = [
  {
    path: "/docuforms",
    name: "docuforms",
    component: DocuformsPage
  },
  {
    path: "/docuform-delete-confirmation",
    name: "docuform-delete-confirmation",
    component: DocuformDeleteConfirmationDialog
  }
];

export default routes;
